export default __webpack_public_path__ + "static/media/limit~bfQnTILx.7532fbbc.svg";